(function () {
  /**
   * @ngdoc directive
   * @name kareo.ui.shared.assets:kHighlightMatchedText
   * @restrict E
   * @scope
   * @description
   * Highlights the longest matching substring in two strings
   * ========================================================
   * > This is currently only used for highlighting search results when
   * > creating a patient. If you're going to reuse it, we should refactor it
   * > out of the k-edit-patient namespace and determine the desired behavior
   * > (ex highlighting all matched substrings that meet a certain threshold).
   *
   * @param {String} needle the "source" string from which to find the longest
   * match
   * @param {String} haystack the body of text to display and highlight the
   * (case-insensitive) longest match inside of
   * @example
   <example module="kareo.ui.shared.directives.k-edit-patient.private.k-highlight-matched-text">
   <file name="index.html">
   <div class="kareo" ng-controller="kHighlightMatchedTextDemoCtrl" >
   <p><k-highlight-matched-text needle="reallysomestring"
      haystack="somereallylongstring"></k-highlight-matched-text></p>

   <p><k-highlight-matched-text needle="kareo"
      haystack="WELCOME TO KAREO"></k-highlight-matched-text></p>

   <p><k-highlight-matched-text needle="exactmatch"
      haystack="exactmatch"></k-highlight-matched-text></p>

   <p><k-highlight-matched-text needle="Got milk I drink your milkshake burt reynolds karl marx?" haystack="Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
   Imperial caterpillar godlike lady magnets goose trimmed magnum pi, trimmed imperial goose lady magnets cappuccino catcher godlike caterpillar magnum pi mustachio mouth coiffure, horseshoe freestyle lady magnets caterpillar mouth coiffure imperial cappuccino catcher mouth coiffure Freddie mercury trimmed magnum pi tom selleck godlike mustachio goose.
   Worn with distinction hair trimmer godlike ian botham brad pitt dis pencil, worn with distinction ian botham lemmy dis landed gentry vincent price brad pitt hair trimmer pencil vincent price godlike. Man markings goose tache country baron, dali john aldridge goose don’t panic tache country baron man markings brandy professor plum village people yeoman farmer, man markings brandy cappuccino collector country baron john aldridge ned flanders professor plum charity donate tache marquess of queensbury professor plum don’t panic goose village people yeoman farmer dali freestyle charming villain prostate cancer?
   Got milk I drink your milkshake burt reynolds karl marx?
   D’artagnan clone zone shopper worn with distinction country baron et sodales cun, et sodales cun d’artagnan lipwig country baron clone zone shopper worn with distinction Daniel plainview omar sharif jimi hendrix tricky sneezes? Albert einstein mr frothy-top fu manchu great dictator ian botham saddam hussein d’artagnan class definer."></k-highlight-matched-text></p>

   <div>
     <input type="text" ng-model="needle" placeholder="needle"/>
     <textarea ng-model="haystack" placeholder="haystack"></textarea>
     <p>
       <k-highlight-matched-text needle="{{needle}}" haystack="{{haystack}}">
       </k-highlight-matched-text>
     </p>
   </div>

   </div>
   </file>
   <file name="demo.js">
   angular
    .module('kareo.ui.shared.directives.k-edit-patient.private.k-highlight-matched-text')
    .controller('kHighlightMatchedTextDemoCtrl', ['$scope', function($scope){
       $scope.needle = '';
       $scope.haystack = '';
     }]);
   </file>

   </example>
   */

  angular
    .module('kareo.ui.shared.directives.k-edit-patient.private.k-highlight-matched-text', [
      'kareo.ui.shared.directives.templates'
    ])
    .directive('kHighlightMatchedText', kHighlightMatchedText);

  function kHighlightMatchedText() {
    return {
      bindToController: true,
      controller,
      controllerAs: 'vm',
      restrict: 'E',
      scope: {
        haystack: '@',
        needle: '@'
      },
      template: require('./k-highlight-matched-text.pug')()
    };
  }

  controller.$inject = ['$scope'];
  function controller($scope) {
    var vm = this;

    $scope.$watch('vm.needle', highlight);
    $scope.$watch('vm.haystack', highlight);

    // --------------------------------------------------------------------

    function highlight() {
      var haystackMatchStartPos, match;

      vm.beforeMatch = vm.haystack;
      vm.match = '';
      vm.afterMatch = '';

      if (typeof vm.needle !== 'string' || typeof vm.haystack !== 'string') {
        return;
      }

      match = longestCommonSubstring(vm.needle.toUpperCase(),
        vm.haystack.toUpperCase());

      haystackMatchStartPos = match.str2StartPos;

      vm.beforeMatch = vm.haystack.substr(0, haystackMatchStartPos);
      vm.match = vm.haystack.substr(haystackMatchStartPos, match.length);
      vm.afterMatch = vm.haystack.substr(haystackMatchStartPos + match.length);
    }
  }

  /*
   * This algorithm is slightly difficult to read, but is the ideal solution to
   * run in the browser as it only uses O(m) storage vs the common O(n*m)
   * storage or O(m) call stack (recursive) in simpler solutions, where n is
   * the length of str1 and m is the length of str2
   * Need more information?
   *
   * Adapted from Java implementation at:
   * https://en.wikibooks.org/wiki/Algorithm_Implementation/Strings/Longest_common_substring#Java_-_O.28n.29_storage
   */
  function longestCommonSubstring(str1, str2) {
    var cost = 0, costs1 = [], costs2 = [], maxLen = 0, result, str1EndPos = 0,
      str2EndPos = 0, str1Index, str2Index, str1StartPos, str2StartPos, swap;

    result = {
      length: 0,
      str1StartPos: 0,
      str2StartPos: 0
    };

    if (!str1 || !str2 || typeof str1 !== 'string' || typeof str2 !== 'string') {
      return result;
    }

    for (str1Index = 0; str1Index < str1.length; str1Index++) {
      for (str2Index = 0; str2Index < str2.length; str2Index++) {
        // calculate cost/score
        if (str1[str1Index] !== str2[str2Index]) {
          cost = 0;
        } else if ((str1Index === 0) || (str2Index === 0)) {
            cost = 1;
          } else {
            cost = costs1[str2Index - 1] + 1;
          }

        costs2[str2Index] = cost;

        if (cost > maxLen) {
          maxLen = cost;
          str1EndPos = str1Index;
          str2EndPos = str2Index;
        }
      }

      swap = costs1;
      costs1 = costs2;
      costs2 = swap;
    }

    if (maxLen > 0) {
      str1StartPos = str1EndPos - maxLen + 1;
      str2StartPos = str2EndPos - maxLen + 1;

      result.length = maxLen;
      result.str1StartPos = str1StartPos;
      result.str2StartPos = str2StartPos;
    }

    return result;
  }
})();
